var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-footer',{attrs:{"id":"Footer"}},[_c('div',{staticClass:"copyright"},[_vm._v("\n\t\t© 2018 "),_c('a',{attrs:{"href":"http://ribrit.com"}},[_vm._v("Ribrit.com")]),_vm._v(".\n\t")])])}
var staticRenderFns = []

export { render, staticRenderFns }